import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DocumentImage16Icon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M4.67 8.67a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-.67a.67.67 0 1 0 0 1.33.67.67 0 0 0 0-1.33Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M4 .67a2 2 0 0 0-2 2v10.66a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a.67.67 0 0 0-.2-.47L10.14.86a.67.67 0 0 0-.47-.2H4Zm8.67 9.15V6H9.33a.67.67 0 0 1-.66-.67V2H4a.67.67 0 0 0-.67.67v10.66A.67.67 0 0 0 4 14h2.39l3.87-3.87a2 2 0 0 1 2.4-.31ZM8.27 14H12a.67.67 0 0 0 .67-.67v-1.72l-.53-.53a.67.67 0 0 0-.94 0L8.28 14Zm3.79-9.33H10V2.6l2.06 2.06Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default DocumentImage16Icon;
